export const PRODUCT_FETCH_REQUEST = "PRODUCT_FETCH_REQUEST";
export const PRODUCT_FETCH_SUCCESS = "PRODUCT_FETCH_SUCCESS";
export const PRODUCT_FETCH_FAILURE = "PRODUCT_FETCH_FAILURE";
export const FILTER_PRODUCT = "FILTER_PRODUCT";
export const SORT_PRODUCT = "SORT_PRODUCT";
export const SET_LIMIT_PRODUCT = "SET_LIMIT_PRODUCT";
export const SET_PAGE_PRODUCT = "SET_PAGE_PRODUCT";
